import React, { useState, useEffect } from "react";
import axios from "axios";
import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import OrgTabs from "./OrgTabs";
import config from "../../config";
import AlertBox from '../AlertBox.js';
import { startLoader, stopLoader } from "../../actions/loaderActions";
import { useDispatch } from 'react-redux';
import ConfirmDialog from '../ConfirmDialog.js';
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Card,
  CardContent,
  Grid
} from "@material-ui/core";
import Select from "react-select";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import TableSortLabel from '@material-ui/core/TableSortLabel';


const ApiBaseUrl = config.NodeApiBaseUrl;
const getDefaultHeaders = () => ({
  "x-tenant-schema": "Amplo111",
  "x-user-id": localStorage.getItem("UserId") || "",
  "x-user-email": sessionStorage.getItem("userEmail") || ""
});
const OperationalUnit = () => {
  const dispatch = useDispatch();
  const [entities, setEntities] = useState([]);
  const [groupedEntities, setGroupedEntities] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingUnitId, setEditingUnitId] = useState(null);
  const [previewUnit, setPreviewUnit] = useState(null);
  const [industryTags, setIndustryTags] = useState([]);


  const [operatingUnit, setOperatingUnit] = useState({
    company_id: "",
    entity_id: "",
    name: "",
    country: "",
    type_of_operation: "",
    type_of_operation_description: "",
    industry_tag: [],
    location: "",
    num_employees: "",
    revenue_contribution_percent: "",
    products: [],
    services: []
  });

  const countries = ["India", "USA", "UK", "Germany", "Canada"];
  const operationTypes = [
    "Shop",
    "Establishment",
    "Factory",
    "Mine",
    "Oilfield",
    "Dock",
    "Port",
    "Warehouse/Godown",
    "Plantation"
  ];
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: '',
    content: '',
    onConfirm: () => { },
  });

  const [unitSortConfig, setUnitSortConfig] = useState({ key: '', direction: 'asc' });
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [unitFilter, setUnitFilter] = useState('');
  const [initialFormState, setInitialFormState] = useState(null);



  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    axios.get('https://countriesnow.space/api/v0.1/countries/positions')
      .then((res) => {
        const countries = res.data.data.map(c => ({ label: c.name, value: c.name }));
        setCountryOptions(countries);
      })
      .catch(err => console.error('Failed to load countries', err));
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      axios.post('https://countriesnow.space/api/v0.1/countries/states', {
        country: selectedCountry
      })
        .then((res) => {
          const states = res.data.data.states.map(s => ({ label: s.name, value: s.name }));
          setStateOptions(states);
        })
        .catch(err => console.error('Failed to load states', err));
    } else {
      setStateOptions([]);
    }
  }, [selectedCountry]);

  const fetchEntities = async (companyId) => {
    if (!companyId) return;
    try {
      const res = await axios.get(`${ApiBaseUrl}getAllEntities/${companyId}`, {
        headers: getDefaultHeaders(),
      });
      const data = res.data.data || [];
      setEntities(data);
      // If no entity is selected yet, fallback to company-level tag
      const company = companies.find(c => c.company_id === companyId);
      if (company?.industry_tag) {
        setIndustryTags(company.industry_tag);
      } else {
        setIndustryTags([]);
      }
    } catch (err) {
      console.error("Error fetching entities", err);
    }
  };

  const fetchGroupedOperatingUnits = async (companyList) => {
    dispatch(startLoader());
    try {
      const allGrouped = {};
      for (const company of companyList) {
        const res = await axios.get(
          `${ApiBaseUrl}getAllOperatingUnits?companyId=${company.company_id}`,
          { headers: getDefaultHeaders() }
        );
        const units = res.data.data || [];
        if (units.length > 0) {
          allGrouped[company.name] = units;
        }
      }
      setGroupedEntities(allGrouped);
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("Error fetching grouped operating units", err);
    }
  };

  const fetchCompanies = async () => {
    dispatch(startLoader());
    try {
      const res = await axios.get(`${ApiBaseUrl}getAllCompanies`, {
        headers: getDefaultHeaders(),
      });
      let companyList = res.data.data || [];

      // Super Admin Restriction: Filter by Project Selection "Client"
      const userEmail = sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail");
      if (userEmail && userEmail.toLowerCase() === "superadmin@amplo.com") {
        try {
          const projectSelectionStr = sessionStorage.getItem("projectSelection");
          if (projectSelectionStr) {
            const projectSelection = JSON.parse(projectSelectionStr);
            if (projectSelection.client && projectSelection.client.company_id) {
              const selectedId = String(projectSelection.client.company_id);
              companyList = companyList.filter(c => String(c.company_id) === selectedId);
            }
          }
        } catch (e) {
          console.warn("Error parsing projectSelection for company filtering:", e);
        }
      }

      setCompanies(companyList);
      for (const company of companyList) {
        const comp = companyList.find(c => c.company_id === company.company_id);
        if (comp?.industry_tag) {
          setIndustryTags(comp.industry_tag);
        }
      }

      await fetchGroupedOperatingUnits(companyList);
      dispatch(stopLoader());
    } catch (err) {
      dispatch(stopLoader());
      console.error("Error fetching companies", err);
    }
  };

  const handleAdd = (type) => {
    const updated = [...operatingUnit[type], { name: "", revenue_share: "" }];
    setOperatingUnit({ ...operatingUnit, [type]: updated });

    setInitialFormState({
      company_id: "",
      entity_id: "",
      name: "",
      country: "",
      type_of_operation: "",
      industry_tag: [],
      location: "",
      num_employees: "",
      revenue_contribution_percent: "",
      products: [],
      services: [],
    });


  };

  const handleRemove = (type, idx) => {
    const updated = [...operatingUnit[type]];
    updated.splice(idx, 1);
    setOperatingUnit({ ...operatingUnit, [type]: updated });
  };

  const handleChange = (type, idx, field, value) => {
    const updated = [...operatingUnit[type]];
    updated[idx][field] = value;
    setOperatingUnit({ ...operatingUnit, [type]: updated });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(startLoader());
    try {
      const url = isEditMode
        ? `${ApiBaseUrl}updateOperatingUnit/${editingUnitId}`
        : `${ApiBaseUrl}createOperatingUnit`;
      const method = isEditMode ? "put" : "post";

      await axios[method](url, operatingUnit, {
        headers: { ...getDefaultHeaders(), "Content-Type": "application/json" },
      });

      setShowModal(false);
      setIsEditMode(false);
      setEditingUnitId(null);
      fetchCompanies();

      setOperatingUnit({
        company_id: "",
        entity_id: "",
        name: "",
        country: "",
        type_of_operation: "",
        location: "",
        num_employees: "",
        revenue_contribution_percent: "",
        industry_tag: [],
        products: [],
        services: [],
      });
      dispatch(stopLoader());
      showAlert("success", "Operating unit Created successfully.");
    } catch (err) {
      dispatch(stopLoader());
      showAlert("error", "Error saving operating unit");
      console.error("Error saving operating unit", err);
    }
  };

  const handleDeleteUnit = (unitId) => {
    setConfirmDialog({
      open: true,
      title: 'Delete Operating Unit',
      content: 'Are you sure you want to delete this operating unit?',
      onConfirm: async () => {
        try {
          await axios.delete(`${ApiBaseUrl}deleteOperatingUnit/${unitId}`, {
            headers: getDefaultHeaders(),
          });

          setGroupedEntities((prev) => {
            const updated = {};
            for (const [companyName, units] of Object.entries(prev)) {
              const filteredUnits = units.filter((unit) => unit.unit_id !== unitId);
              if (filteredUnits.length > 0) {
                updated[companyName] = filteredUnits;
              }
            }
            return updated;
          });

          showAlert("success", "Operating unit deleted successfully.");
        } catch (err) {
          console.error("❌ Failed to delete unit:", err);
          showAlert("error", "Error deleting unit. Please try again.");
        } finally {
          setConfirmDialog((prev) => ({ ...prev, open: false }));
        }
      }
    });
  };

  const showAlert = (type, msg) => {
    setAlert({ open: true, message: msg, severity: type });
  };

  const handleClose = () => setAlert(prev => ({ ...prev, open: false }));

  const handleUnitSort = (key) => {
    setUnitSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const isFormChanged = () => {
    return JSON.stringify(initialFormState) !== JSON.stringify(operatingUnit);
  };

  return (
    <>
      <DashboardHeader />
      <Box display="flex">
        <DashboardSidebar />
        <Box component="main" flexGrow={1} p={3} mt={5}>
          <Box display="flex" justifyContent="space-between" mb={3} alignItems="center">
            <Typography variant="h5">Organization Structure</Typography>
            <Box display="flex" alignItems="center">
              <img
                src={require("./../../common/images/diva-icon.png")}
                alt="Logo"
                style={{ marginRight: 8, height: 24 }}
              />
              <Typography variant="caption">Powered by Amploglobal</Typography>
            </Box>
          </Box>

          <OrgTabs />

          <Container maxWidth="lg">
            <Box mt={4} justifyContent="space-between" alignItems="center">
              <div className="card-header d-flex justify-content-between">
                <span>All Operating Units</span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setShowModal(true);
                    setIsEditMode(false);
                    setOperatingUnit({
                      company_id: "",
                      entity_id: "",
                      name: "",
                      country: "",
                      type_of_operation: "",
                      location: "",
                      num_employees: "",
                      revenue_contribution_percent: "",
                      products: [],
                      services: [],
                    });
                  }}
                  startIcon={<AddIcon />}
                >
                  Add Operating Unit
                </Button>
              </div>
            </Box>
            <Card variant="outlined">
              <CardContent>
                <Box display="flex" justifyContent="flex-start" alignItems="center" mb={2}>
                  <TextField
                    variant="outlined"
                    placeholder="Search Entity Name..."
                    size="small"
                    value={unitFilter}
                    onChange={(e) => setUnitFilter(e.target.value)}
                    InputProps={{
                      style: {
                        backgroundColor: '#f9f9f9',
                        borderRadius: 8,
                      },
                    }}
                    style={{ width: 260 }}
                  />
                </Box>

                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sortDirection={unitSortConfig.key === 'name' ? unitSortConfig.direction : false}>
                          <TableSortLabel
                            active={true}
                            direction={unitSortConfig.key === 'name' ? unitSortConfig.direction : 'asc'}
                            onClick={() => handleUnitSort('name')}
                            hideSortIcon={false}
                          >
                            Name
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={unitSortConfig.key === 'entity_name' ? unitSortConfig.direction : false}>
                          <TableSortLabel
                            active={true}
                            direction={unitSortConfig.key === 'entity_name' ? unitSortConfig.direction : 'asc'}
                            onClick={() => handleUnitSort('entity_name')}
                            hideSortIcon={false}
                          >
                            Entity
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={unitSortConfig.key === 'location' ? unitSortConfig.direction : false}>
                          <TableSortLabel
                            active={true}
                            direction={unitSortConfig.key === 'location' ? unitSortConfig.direction : 'asc'}
                            onClick={() => handleUnitSort('location')}
                            hideSortIcon={false}
                          >
                            Location
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={unitSortConfig.key === 'type_of_operation' ? unitSortConfig.direction : false}>
                          <TableSortLabel
                            active={true}
                            direction={unitSortConfig.key === 'type_of_operation' ? unitSortConfig.direction : 'asc'}
                            onClick={() => handleUnitSort('type_of_operation')}
                            hideSortIcon={false}
                          >
                            Type of Operation
                          </TableSortLabel>
                        </TableCell>
                        <TableCell sortDirection={unitSortConfig.key === 'industry_tag' ? unitSortConfig.direction : false}>
                          <TableSortLabel
                            active={true}
                            direction={unitSortConfig.key === 'industry_tag' ? unitSortConfig.direction : 'asc'}
                            onClick={() => handleUnitSort('industry_tag')}
                            hideSortIcon={false}
                          >
                            Industry
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Object.entries(groupedEntities).map(([companyName, units]) => {
                        const filteredUnits = units.filter((unit) =>
                          (unit.entity_name || "").toLowerCase().includes(unitFilter.toLowerCase())
                        );

                        return filteredUnits.length > 0 ? (
                          <React.Fragment key={companyName}>
                            {filteredUnits
                              .sort((a, b) => {
                                if (!unitSortConfig.key) return 0;
                                const aVal = a[unitSortConfig.key]?.toString().toLowerCase() || '';
                                const bVal = b[unitSortConfig.key]?.toString().toLowerCase() || '';
                                return unitSortConfig.direction === 'asc'
                                  ? aVal.localeCompare(bVal)
                                  : bVal.localeCompare(aVal);
                              })
                              .map((unit, index) => (
                                <TableRow key={index}>
                                  <TableCell>
                                    <span
                                      onClick={() => setPreviewUnit(unit)}
                                      style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                      {unit.name}
                                    </span>
                                  </TableCell>

                                  <TableCell style={{ width: '200px', maxWidth: '200px', whiteSpace: 'wrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {unit.entity_name || "N/A"}
                                  </TableCell>

                                  <TableCell>  {[
                                    unit?.location?.trim(),
                                    unit?.state?.trim()
                                  ].filter(Boolean).join(", ") || "-"}</TableCell>
                                  <TableCell> {(unit.type_of_operation_description && unit.type_of_operation_description.trim())
                                    ? unit.type_of_operation_description
                                    : (unit.type_of_operation || "-")}</TableCell>
                                  <TableCell>
                                    {(unit.display_industry && unit.display_industry.trim())
                                      ? unit.display_industry
                                      : (unit.industry_tag || "N/A")}
                                  </TableCell>

                                  <TableCell>
                                    <Tooltip title="Edit">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          const selectedCompany = companies.find(c => c.company_id === unit.company_id);
                                          const selectedEntity = entities.find(e => e.entity_id === unit.entity_id);
                                          let tagList = [];

                                          if (selectedEntity?.industry_tag?.length > 0) {
                                            tagList = selectedEntity.industry_tag;
                                          } else if (selectedCompany?.industry_tag?.length > 0) {
                                            tagList = selectedCompany.industry_tag;
                                          }

                                          setIndustryTags(tagList);
                                          setShowModal(true);
                                          setIsEditMode(true);
                                          setEditingUnitId(unit.unit_id);
                                          setSelectedCountry(unit.country);
                                          setInitialFormState({ ...unit });
                                          setOperatingUnit({
                                            ...unit,
                                            products: unit.products || [],
                                            services: unit.services || [],
                                            industry_tag: unit.industry_tag || "",
                                            state: unit.state || '',
                                          });
                                        }}
                                      >
                                        <EditIcon />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Preview">
                                      <IconButton size="small" onClick={() => setPreviewUnit(unit)}>
                                        <VisibilityIcon />
                                      </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Delete">
                                      <IconButton
                                        color="secondary"
                                        size="small"
                                        onClick={() => handleDeleteUnit(unit.unit_id)}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </React.Fragment>
                        ) : null;
                      })}

                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </Box>
      {/* Operating Unit Form Dialog */}
      <Dialog open={showModal}
        onClose={() => {
          if (isFormChanged()) {
            setConfirmDialog({
              open: true,
              title: 'Unsaved Changes',
              content: 'Changes will be lost. Do you want to exit?',
              onConfirm: () => {
                setShowModal(false);
                setConfirmDialog((prev) => ({ ...prev, open: false }));
              }
            });
          } else {
            setShowModal(false);
          }
        }}
        maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? "Edit Operating Unit" : "Add Operating Unit"}</DialogTitle>
        <IconButton
          onClick={() => {
            if (isFormChanged()) {
              setConfirmDialog({
                open: true,
                title: 'Unsaved Changes',
                content: 'Changes will be lost. Do you want to exit?',
                onConfirm: () => {
                  setShowModal(false);
                  setConfirmDialog((prev) => ({ ...prev, open: false }));
                }
              });
            } else {
              setShowModal(false);
            }
          }}
          style={{
            position: 'absolute',
            right: 0,
            top: '15px',
            color: '#888',
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <form onSubmit={handleSubmit}>
          <DialogContent dividers sx={{ maxHeight: "70vh", overflowY: "auto" }}>
            <Grid container spacing={2}>
              {/* 1. Linked Company */}
              <Grid item xs={4}>
                <InputLabel>Linked Company</InputLabel>
                <Select
                  options={[...companies]
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(c => ({ label: c.name, value: c.company_id }))}
                  value={
                    companies.find(c => c.company_id === operatingUnit.company_id)
                      ? {
                        label: companies.find(c => c.company_id === operatingUnit.company_id).name,
                        value: operatingUnit.company_id,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    const selectedCompany = companies.find(c => c.company_id === selected.value);
                    setIndustryTags(selectedCompany?.industry_tag || []);
                    setOperatingUnit({
                      ...operatingUnit,
                      company_id: selected.value,
                      entity_id: '',
                      industry_tag: '',
                    });
                    fetchEntities(selected.value);
                  }}
                />
              </Grid>

              {/* 2. Linked Entity */}
              {entities.filter(e => e.company_id === operatingUnit.company_id).length > 0 && (
                <Grid item xs={4}>
                  <InputLabel>Linked Entity</InputLabel>
                  <Select
                    options={[...entities]
                      .filter(e => e.company_id === operatingUnit.company_id)
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(e => ({ label: e.name, value: e.entity_id }))}

                    value={
                      entities.find(e => e.entity_id === operatingUnit.entity_id)
                        ? {
                          label: entities.find(e => e.entity_id === operatingUnit.entity_id).name,
                          value: operatingUnit.entity_id,
                        }
                        : null
                    }
                    onChange={(selected) => {
                      setOperatingUnit({ ...operatingUnit, entity_id: selected?.value || '' });
                      const selectedEntity = entities.find(ent => ent.entity_id === selected.value);
                      if (selectedEntity?.industry_tag) {
                        setIndustryTags(selectedEntity.industry_tag);
                      } else {
                        const selectedCompany = companies.find(c => c.company_id === operatingUnit.company_id);
                        setIndustryTags(selectedCompany?.industry_tag || []);
                      }
                    }}
                  />
                </Grid>
              )}

              {/* 3. Industry Tag */}
              <Grid item xs={4}>
                <InputLabel>Industry Tag</InputLabel>
                <Select
                  options={[...industryTags]
                    .sort((a, b) => a.localeCompare(b))
                    .map(tag => ({ label: tag, value: tag }))}

                  value={
                    industryTags.includes(operatingUnit.industry_tag)
                      ? { label: operatingUnit.industry_tag, value: operatingUnit.industry_tag }
                      : null
                  }
                  onChange={(selected) => setOperatingUnit({ ...operatingUnit, industry_tag: selected.value })}
                />
              </Grid>

              {/* 4. Name */}
              <Grid item xs={4}>
                <TextField
                  label="Name"
                  fullWidth
                  value={operatingUnit.name}
                  onChange={(e) => setOperatingUnit({ ...operatingUnit, name: e.target.value })}
                />
              </Grid>

              {/* 5. Type of Operation */}
              <Grid item xs={4}>
                <InputLabel>Type of Operation</InputLabel>
                <Select
                  options={[...operationTypes]
                    .sort((a, b) => a.localeCompare(b))
                    .map(op => ({ label: op, value: op }))}

                  value={
                    operationTypes.includes(operatingUnit.type_of_operation)
                      ? { label: operatingUnit.type_of_operation, value: operatingUnit.type_of_operation }
                      : null
                  }
                  onChange={(selected) => setOperatingUnit({ ...operatingUnit, type_of_operation: selected.value })}
                />
              </Grid>

              {/* 5b. Description of Type of Operation */}
              <Grid item xs={4}>
                <TextField
                  label="Description of Type of Operation"
                  placeholder="Optional"
                  fullWidth
                  value={operatingUnit.type_of_operation_description}
                  onChange={(e) =>
                    setOperatingUnit({ ...operatingUnit, type_of_operation_description: e.target.value })
                  }
                />
              </Grid>


              {/* 7. Country */}
              <Grid item xs={4}>
                <InputLabel>Country</InputLabel>
                <Select
                  options={countryOptions}
                  value={countryOptions.find(opt => opt.value === operatingUnit.country) || null}
                  onChange={(selected) => {
                    setSelectedCountry(selected.value);
                    setOperatingUnit({ ...operatingUnit, country: selected.value, state: '' });
                  }}
                />
              </Grid>

              {/* 8. State */}
              <Grid item xs={4}>
                <InputLabel>State</InputLabel>
                <Select
                  options={stateOptions}
                  value={stateOptions.find(opt => opt.value === operatingUnit.state) || null}
                  onChange={(selected) => setOperatingUnit({ ...operatingUnit, state: selected.value })}
                  isDisabled={!stateOptions.length}
                />

              </Grid>

              {/* 6. Location */}
              <Grid item xs={4}>
                <TextField
                  label="Location"
                  fullWidth
                  value={operatingUnit.location}
                  onChange={(e) => setOperatingUnit({ ...operatingUnit, location: e.target.value })}
                />
              </Grid>


              {/* 9. Number of Employees */}
              <Grid item xs={4}>
                <TextField
                  label="Number of Employees"
                  type="number"
                  fullWidth
                  value={operatingUnit.num_employees}
                  onChange={(e) => setOperatingUnit({ ...operatingUnit, num_employees: e.target.value })}
                />
              </Grid>

              {/* 10. Revenue Contribution % */}
              <Grid item xs={4}>
                <TextField
                  label="Revenue Contribution %"
                  type="number"
                  fullWidth
                  value={operatingUnit.revenue_contribution_percent}
                  onChange={(e) => setOperatingUnit({ ...operatingUnit, revenue_contribution_percent: e.target.value })}
                />
              </Grid>


              <Grid item xs={12}>
                <Box mt={3}>
                  <Card elevation={2}>
                    <Box p={3}>
                      {["products", "services"].map((type) => (
                        <Box key={type} mb={4}>
                          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h7">
                              {type.charAt(0).toUpperCase() + type.slice(1)}
                            </Typography>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() => handleAdd(type)}
                              style={{ textTransform: "none" }}
                            >
                              + Add {type.slice(0, -1)}
                            </Button>
                          </Box>

                          {operatingUnit[type]?.map((item, idx) => (
                            <Card key={idx} variant="outlined" style={{ marginBottom: 24 }}>
                              <Box p={3}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                  <Typography variant="subtitle1">
                                    {type.charAt(0).toUpperCase() + type.slice(1)} #{idx + 1}
                                  </Typography>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => handleRemove(type, idx)}
                                  >
                                    Delete
                                  </Button>
                                </Box>

                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      label="Name"
                                      placeholder="Name"
                                      value={item.name}
                                      onChange={(e) => handleChange(type, idx, "name", e.target.value)}
                                      fullWidth
                                    />
                                  </Grid>
                                  <Grid item xs={12} sm={6}>
                                    <TextField
                                      label="Revenue Share %"
                                      placeholder="Revenue Share %"
                                      type="number"
                                      value={item.revenue_share}
                                      onChange={(e) => handleChange(type, idx, "revenue_share", e.target.value)}
                                      fullWidth
                                    />
                                  </Grid>
                                </Grid>
                              </Box>
                            </Card>
                          ))}
                        </Box>
                      ))}
                    </Box>
                  </Card>
                </Box>
              </Grid>

            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              if (isFormChanged()) {
                setConfirmDialog({
                  open: true,
                  title: 'Unsaved Changes',
                  content: 'Changes will be lost. Do you want to exit?',
                  onConfirm: () => {
                    setShowModal(false);
                    setConfirmDialog((prev) => ({ ...prev, open: false }));
                  }
                });
              } else {
                setShowModal(false);
              }
            }}
              color="secondary">Cancel</Button>
            <Button type="submit" variant="contained" color="primary">
              {isEditMode ? "Update Unit" : "Create Unit"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {/* Preview Unit Form Dialog */}
      <Dialog open={!!previewUnit} onClose={() => setPreviewUnit(null)} maxWidth="md" fullWidth>
        <DialogTitle style={{ backgroundColor: '#CEDBE6', color: '#fff', fontWeight: 600, marginTop: 15 }}>Operating Unit Preview
          <IconButton
            onClick={() => {
              setPreviewUnit(null)
            }}
            style={{
              position: 'absolute',
              right: 0,
              top: '25px',
              color: '#888',
            }}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ backgroundColor: "#f9f9f9" }}>
          <Box p={2}>
            {/* Basic Info */}
            <Card elevation={1} style={{ padding: 24, marginBottom: 24 }}>
              <Typography variant="h5" style={{ marginBottom: 16, fontWeight: 600 }}>
                {previewUnit?.name || "-"}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Company</Typography>
                  <Typography>{companies.find(c => c.company_id === previewUnit?.company_id)?.name || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Entity</Typography>
                  <Typography>{previewUnit?.entity_name || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Country</Typography>
                  <Typography>{previewUnit?.country || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">State</Typography>
                  <Typography>{previewUnit?.state || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Type of Operation</Typography>
                  <Typography>{previewUnit?.type_of_operation || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary"> Description of Type of Operation</Typography>
                  <Typography>{previewUnit?.type_of_operation_description || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Location</Typography>
                  <Typography>
                    {[
                      previewUnit?.location?.trim(),
                      previewUnit?.state?.trim()
                    ].filter(Boolean).join(", ") || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Employees</Typography>
                  <Typography>{previewUnit?.num_employees || "-"}</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" color="textSecondary">Revenue %</Typography>
                  <Typography>{previewUnit?.revenue_contribution_percent || "-"}</Typography>
                </Grid>
              </Grid>
            </Card>

            {/* Products */}
            {(previewUnit?.products || []).length > 0 && (
              <Card elevation={1} style={{ padding: 24, marginBottom: 24 }}>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>Products</Typography>
                <Grid container spacing={2}>
                  {/* Header Row */}
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="textSecondary">Product</Typography>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: "right" }}>
                    <Typography variant="subtitle2" color="textSecondary">Revenue Share %</Typography>
                  </Grid>

                  {previewUnit.products.map((p, idx) => (
                    <Grid item xs={12} key={idx}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={6}>
                          <Box style={{
                            backgroundColor: "#e3f2fd",
                            borderRadius: 20,
                            padding: "6px 14px",
                            display: "inline-block",
                          }}>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              {p.name}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                          <Box style={{
                            backgroundColor: "#e1f5fe",
                            borderRadius: 20,
                            padding: "6px 14px",
                            display: "inline-block",
                          }}>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              {p.revenue_share}%
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            )}


            {/* Services */}
            {(previewUnit?.services || []).length > 0 && (
              <Card elevation={1} style={{ padding: 24 }}>
                <Typography variant="h6" style={{ fontWeight: 600, marginBottom: 12 }}>Services</Typography>
                <Grid container spacing={2}>
                  {/* Header Row */}
                  <Grid item xs={6}>
                    <Typography variant="subtitle2" color="textSecondary">Service</Typography>
                  </Grid>
                  <Grid item xs={6} style={{ textAlign: "right" }}>
                    <Typography variant="subtitle2" color="textSecondary">Revenue Share %</Typography>
                  </Grid>

                  {previewUnit.services.map((s, idx) => (
                    <Grid item xs={12} key={idx}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item xs={6}>
                          <Box style={{
                            backgroundColor: "#fce4ec",
                            borderRadius: 20,
                            padding: "6px 14px",
                            display: "inline-block",
                          }}>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              {s.name}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6} style={{ textAlign: "right" }}>
                          <Box style={{
                            backgroundColor: "#f8bbd0",
                            borderRadius: 20,
                            padding: "6px 14px",
                            display: "inline-block",
                          }}>
                            <Typography variant="body2" style={{ fontWeight: 500 }}>
                              {s.revenue_share}%
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Card>
            )}

          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setPreviewUnit(null)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <AlertBox
        open={alert.open}
        onClose={handleClose}
        message={alert.message}
        severity={alert.severity}
      />
      <ConfirmDialog
        open={confirmDialog.open}
        title={confirmDialog.title}
        content={confirmDialog.content}
        onCancel={() => setConfirmDialog({ ...confirmDialog, open: false })}
        onConfirm={confirmDialog.onConfirm}
      />

      <FooterComponent />
    </>
  );
};

export default OperationalUnit;

